module.exports = __webpack_public_path__ + "static/media/100dollars.708f448a.png";